<template>
  <div class="body-wrapper">
    <div class="login-wrapper">
      <div class="login">
        <!--promeniti slicicu kad stigne bolja-->
        <div class="logo-wrapper">
          <img src="@/assets/logo.png" alt="logo" />
        </div>
        <form @submit.prevent="logIn">
          <div class="form-group row">
            <div class="col-sm-12">
              <label class="col-form-label col-form-label-lg">Email</label>
              <input
                type="email"
                class="form-control form-control-lg"
                placeholder="Unesite svoj email"
                v-model="credentials.email"
                @focus="errorOccurred = false"
                required
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12">
              <label class="col-form-label col-form-label-lg">Šifra</label>
              <input
                type="password"
                class="form-control form-control-lg"
                placeholder="Unesite svoju šifru"
                v-model="credentials.password"
                @focus="errorOccurred = false"
                required
              />
            </div>
          </div>
          <div class="text-center">
            <button type="submit" class="btn btn-primary mb-2">
              Prijavi se
            </button>
            <spinner line-fg-color="#00796b" v-if="loading" />
            <p id="password-forgotten">
              Zaboravili ste lozinku? Kliknite
              <router-link to="/password">
                <span @click="showModal('ModalContentResetPassword')"
                  >ovde.</span
                >
              </router-link>
            </p>
            <transition enter-active-class="animated shake">
              <p class="error-msg" v-if="errorOccurred">{{ errorMessage }}</p>
            </transition>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapMutations, mapState } from 'vuex';
import { UserRoles } from '@/util/UtilService.js';

/*
 *   a login view. entry point to application
 * */
export default {
  data() {
    return {
      credentials: {
        email: '',
        password: ''
      },
      errorOccurred: false,
      errorMessage: ''
    };
  },
  computed: {
    ...mapState(['loading', 'refreshInterval'])
  },
  methods: {
    ...mapMutations('modal', ['showModal']),
    ...mapMutations([
      'setCommunities',
      'setUser',
      'setCompany',
      'loadingStarted',
      'loadingFinished',
      'setActiveCommunity',
      'setRefreshInterval'
    ]),

    logIn() {
      this.loadingStarted();
      axios
        .post('user/login', this.credentials)
        .then(({ data, headers }) => {
          // document.cookie =
          //   'username=' +
          //   headers.auth.split(' ')[1] +
          //   'expires=Thu, 18 Dec 2019 12:00:00 UTC;';
          localStorage.setItem('k-t', headers.auth.split(' ')[1]);

          //setting jwt to every axios headers
          axios.defaults.headers.common['Auth'] = headers.auth.split(' ')[1];
          //setting active user in vuex
          this.setUser({
            username: data.full_name,
            email: data.email,
            id: data.id,
            phone: data.phone,
            profile_pic_URL: data.profile_pic_URL,
            roles: data.roles
          });
          this.setCompany(data.company);
          localStorage.setItem('k-com', JSON.stringify(data.company));
          // check if user is super manager (can login with zero communities)
          let isSuperManager = false;
          if (data.roles.indexOf(UserRoles.SUPER_MANAGER) != -1) {
            isSuperManager = true;
          }
          //setting communities in which user is manager
          if (!data.communities && !isSuperManager) {
            this.loadingFinished();
            //error handling
            this.errorOccurred = true;
            this.errorMessage = 'Niste upravnik nijedne zajednice.';
            localStorage.removeItem('k-t');
            return;
          }
          let communitiesOfManager = [];
          if (data.communities) {
            communitiesOfManager = data.communities.filter(
              c => c.is_manager === '1'
            );
          }

          if (communitiesOfManager.length === 0 && !isSuperManager) {
            this.loadingFinished();
            //error handling
            this.errorOccurred = true;
            this.errorMessage = 'Niste upravnik nijedne zajednice.';
            localStorage.removeItem('k-t');
            return;
          }

          for (let c of communitiesOfManager) {
            c.notifications = {
              polls: 0,
              tickets: 0,
              members: 0,
              unreadNotificationsCount: 0
            };
          }

          this.setCommunities(communitiesOfManager);
          this.$store.commit('setLastActiveCommunities', []);
          this.$store.commit(
            'setLastActiveCommunities',
            this.$store.getters.getLastActiveCommunities
          );
          console.log('klast', this.$store.getters.getLastActiveCommunities);
          data.communities = communitiesOfManager;
          localStorage.setItem('k-d', JSON.stringify(data));

          if (communitiesOfManager[0]) {
            this.setActiveCommunity(communitiesOfManager[0].community_id);
            localStorage.setItem(
              'k-active-c-id',
              communitiesOfManager[0].community_id
            );
            localStorage.setItem('k-last-active', JSON.stringify([]));
          }
          axios
            .get('notifications/?offset=0&isManager=1')
            .then(({ data }) => {
              this.$store.dispatch('updateNotifications', data);
            })
            .catch(err => {
              console.log(err);
            });

          this.loadingFinished();
          if (this.refreshInterval == null) {
            const refreshInterval = setInterval(() => {
              this.$store.dispatch('updateNumberOfUnreadNotifications');
              this.$store.dispatch('updateNotifications');
            }, 4000);
            this.setRefreshInterval(refreshInterval);
          }
          this.$router.push('/');
        })
        .catch(error => {
          this.loadingFinished();
          //error handling
          console.log(error);
          this.errorOccurred = true;
          if (error.response) {
            if (error.response.status == 404 || error.response.status == 401) {
              this.errorMessage = 'Uneti mail ili šifra nisu tačni.';
            } else if (error.response.status >= 500) {
              this.errorMessage = 'Greška na serveru. Pokušajte kasnije.';
            } else {
              this.errorMessage = 'Došlo je do greške. Pokušajte kasnije.';
            }
          } else {
            this.errorMessage =
              'Server trenutno nije dostupan. Pokušajte kasnije.';
          }
        });
    }
  }
};
</script>

<style scoped>
.body-wrapper {
  height: 100%;
  background-image: url('../assets/login-background-blured.png');
}
.login-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 2%;
  margin-bottom: 1%;
}
.logo-wrapper {
  text-align: center;
  padding: 2rem;
}

img {
  max-width: 90%;
  height: auto;
}

.login {
  width: 550px;
  height: 700px;
  background-color: white;
  -webkit-box-shadow: 7px 11px 48px 10px rgba(0, 0, 0, 0.37);
  -moz-box-shadow: 7px 11px 48px 10px rgba(0, 0, 0, 0.37);
  box-shadow: 7px 11px 48px 10px rgba(0, 0, 0, 0.37);
}

img {
  width: 95%;
}

form {
  padding: 2rem;
}

.form-control.form-control-lg:focus {
  box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
}

.error-msg {
  color: red;
}

#password-forgotten {
  margin-top: 15px;
}
</style>
